const messages = {
  en: {
    related: 'Related Videos'
  },
  'es-ud': {
    related: 'Videos Relacionados'
  },
  es: {
    related: 'Videos Relacionados'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/Videos/messages.js